import React, { useEffect } from 'react';
import { ParagraphSBold } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { ShowInTest } from '../../../components/ShowInTest/ShowInTest';
import { Slot, useGlobalSearchParams, useRouter, useSegments } from 'expo-router';
import { Toggle, ToggleProps } from '../../../components/Toggle/Toggle';
import { URL } from '../../../config/config';
import { View } from 'react-native';
import { concatPath } from '../../../utils/links/concatPath';
import { loginKey, registerKey } from '../../../constants/routeKeys';
import { registrationCodeStringForStore } from '../../../constants/storageKeys';
import { useStores } from '../../../hooks/useStores';

export const MARGIN_BOTTOM_BUTTON = 10;



export default function Layout() {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE;
  const router = useRouter();

  const params = useGlobalSearchParams();

  const initialRouteName = registrationCodeStringForStore in params? registerKey: loginKey;

  const segment = useSegments();





  useEffect(() => {
    if (!rootStore.onboarding.firstTime) {
      router.replace('/'+ loginKey);
    }
  }, [rootStore.onboarding?.firstTime]);






  const renderTabBar = () => {
    const isRegister = segment.includes(registerKey);

    const tabs: ToggleProps = {
      indexSelected: isRegister?1:0,
      tabs: [
        {
          label: labels.LOGIN.TITLE || 'Login',
          onPress: () => {router.push(concatPath([loginKey] , 0));}
        },
        {
          label: labels.REGISTER.TITLE || 'Register',
          onPress: () => {router.push(concatPath([registerKey] , 0));}
        },
      ],
    };
    return (
      <View style={{marginHorizontal: 40, marginVertical: SPACING['sp-16']}}>
        <Toggle {...tabs} />
      </View>);

  };


  return (
    <>
      <View style={{ backgroundColor:'white'}}>
        <ShowInTest>
          <ParagraphSBold style={{marginHorizontal: SPACING['sp-40']}}>
            URL={URL}
          </ParagraphSBold>
        </ShowInTest>
        {renderTabBar()}
      </View>
      <Slot initialRouteName={initialRouteName} />
    </>
  );
}
